import React from 'react';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';

const FormRadiobuttonsWrapper = ({
  blok,
  handleInputChange,
  formValue,
  dynamicData,
}) => {
  return (
    (blok.dynamic_data && (
      <div className="flex flex-col items-left mb-6 w-full col-span-12">
        {/* --- --->
        
        TODO: Add dynamic data to the radiobuttons
        
        >--- --- */}
        <span className="text-sm font-normal">{blok.label}</span>
        <div className="m-0 flex flex-col items-left w-full border-none px-3 py-1.5 text-base font-normal">
          {/* --- --->
          
          TODO: Do something with dynamic data, like {dynamicData.map((nestedBlok) => {... 

          >--- --- */}
        </div>
      </div>
    )) || (
      <div
        className="flex flex-col items-left mb-6 w-full col-span-12"
        {...storyblokEditable(blok)}
      >
        <span className="text-sm font-normal px-4 md:px-8">{blok.label}</span>
        <div className="flex w-full border-none m-0 px-4 md:px-8">
          {blok.radiobuttons.map((nestedBlok) => {
            return (
              <StoryblokComponent
                blok={{
                  ...nestedBlok,
                  name: blok.name, // added blok.name to pass the button group name to the children
                }}
                formValue={formValue}
                key={nestedBlok._uid}
                handleInputChange={handleInputChange}
              />
            );
          })}
        </div>
      </div>
    )
  );
};

export default FormRadiobuttonsWrapper;
